import { CanvasContentEmpty } from '@/components/canvas/CanvasContentEmpty/CanvasContentEmpty';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import { useAppSelector } from '@/store/hooks';
import { selectPreviewModeEnabled } from '@/store/system/selectors';
import { CONTENT_BLOCK_NAME } from '@/utils/constants';
import { getBorderRadiusStyle } from '@builder4/shared/utils/styleHelpers';
import type { ContainerProps } from '@builder4/shared/components/Container';
import { useNode } from '@craftjs/core';

function BlankPlaceholder({
  placeholderHeight,
  className,
  hideIllustration = false,
}: {
  placeholderHeight: string;
  className?: string;
  hideIllustration?: boolean;
}) {
  const { getBPProp } = useBreakpointAwareProp(CONTENT_BLOCK_NAME);
  const { props: nodeProps } = useNode((node) => {
    return {
      props: node.data.props as ContainerProps,
    };
  });
  const borderRadius = getBPProp(nodeProps, 'borderRadius');
  const previewMode = useAppSelector(selectPreviewModeEnabled);
  if (previewMode) return null;

  return (
    <div
      style={{
        height: placeholderHeight,
        ...getBorderRadiusStyle(borderRadius || [0, 0, 0, 0]),
      }}
      className={`z-1 flex h-full w-full flex-col items-center justify-center gap-6 hover:bg-indigo-500/10 ${className}`}
    >
      <CanvasContentEmpty
        className="text-center"
        text="Click to edit or drag in elements."
        hideIllustration={hideIllustration}
      />
    </div>
  );
}

export default BlankPlaceholder;
